import { Injectable } from '@angular/core';
import { ViewColumnState } from '../../../application-controller/store/states/view-col.states';
import { PermissionWizardListingComponent } from '../permission-container/permission-wizard/permission-wizard-listing/permission-wizard-listing.component';
import { ViewColumn } from '../../../view-column';
import { PermissionTemplateEditComponent } from '../permission-container/permission-wizard/permission-wizard-listing/permission-wizard-edit/permission-wizard-edit.component';

@Injectable()

// This is where we need to change the view columns.
export class PermissionWizardPagesService {

  private initialState: ViewColumnState = {
    firstColumn: new ViewColumn(0, PermissionWizardListingComponent, 'Permission Wizard Listing', {
      deactivateAdd: false,
      deactivateList: false,
    }),
    secondColumn: null,
    viewCol: [
      new ViewColumn(0, PermissionWizardListingComponent, 'Permission Wizard Listing', {
        deactivateAdd: false,
        deactivateList: false
      }),

      new ViewColumn(1, PermissionTemplateEditComponent, 'Edit Permission Template', {
        deactivateReturn: false,
        selectedIndex: 0
      }),

    ],
    breadCrumbs: [],
    leftDrawer: [],
    rightDrawer: [],
    singleColumn: false,
    prevIndex: null
  };

  get pages() {
    return this.initialState;
  }

  constructor() { }
}
